import React from "react";
import { useUscLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import Icon from "../../styles/Icon";
import IconCard from "../../assets/visuals/card.svg";
import Text from "../../styles/atoms/Text";
import useUscFinanceCalculatorButton from "../../../../hooks/useUscFinanceCalculatorButton";
import * as Styles from "../../common/ServicesWithDetailsList.styles";
import { uscStepTrackingLocationMap } from "../../../../utils/tracking";

const FinanceService = (): JSX.Element => {
    const activeFinanceOption = useUscSelector((state) => state.basket.activeFinanceOption);
    const financeQuoteId = useUscSelector((state) => state.finance.financeQuoteId);
    const step = useUscSelector((state) => state.nav.step);

    const { isDisabled, showCalculator } = useUscFinanceCalculatorButton(uscStepTrackingLocationMap[step]);

    const financeIsActive = activeFinanceOption === "monthly" && !!financeQuoteId;

    const [editDetailsLabel, showDetailsLabel, titleLabel] = useUscLabel([
        "uscServicesFinanceEditDetails",
        "uscServicesFinanceShowDetails",
        "uscServicesFinanceTitle",
    ]);

    return (
        <Styles.ServicesButton type="button" onClick={showCalculator} aria-label={titleLabel} disabled={isDisabled}>
            <div>
                <Styles.MobileIconWrapper>
                    <IconCard />
                </Styles.MobileIconWrapper>
                <Text tag="h3" variant="h6">
                    {titleLabel}
                </Text>
            </div>
            <Styles.FakeButton aria-hidden="true">
                <Styles.ButtonIconWrapper>
                    <Icon variant="plus" />
                </Styles.ButtonIconWrapper>
                <Styles.ButtonText>{financeIsActive ? editDetailsLabel : showDetailsLabel}</Styles.ButtonText>
            </Styles.FakeButton>
        </Styles.ServicesButton>
    );
};

export default FinanceService;
